export default (theme) => ({
  container: {
    maxWidth: 1280,
    [theme.breakpoints.down('xl')]: {
      maxWidth: 1024,
    },
    [theme.breakpoints.down('ml')]: {
      maxWidth: 960,
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: 870,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  fullWidthContainer: {
    maxWidth: '100%',
  },
  content: {
    marginTop: 100,
    [theme.breakpoints.down('md')]: {
      marginTop: 90,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 84,
    },
  },
  authorizationWrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'space-between',
  },
  accessFormWrapper: {
    display: 'flex',
    padding: '20px 0',
    overflow: 'auto',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
  },
  formWrapper: {
    display: 'flex',
    padding: '20px 0',
    overflow: 'auto',
    width: '60%',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  form: {
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  toastsContainer: {
    marginTop: 80,
  },
  toastBody: {
    alignItems: 'flex-start',
  },
  header: {
    margin: '0 auto',
    textAlign: 'center',
    fontSize: 28,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  settingsPage: {
    height: 'calc(100vh - 90px)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100vh - 140px)',
    },
  },
  settingsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 'calc(100% - 20px)',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100% - 40px)',
    },
  },
});
